import httpRequest from "@/utils/httpRequest";
import { getCurrencyName } from "@/crud/sell/selectitems";
import i18n from "@/locales/i18n";
let cfgItem = { qudaoList: [], dateTime: 0, wechatDistMode: 0 };

var sysSpeclist = [
  { value: "spec_size" },
  { value: "spec_weight" },
  { value: "spec_packing" },
  { value: "spec_capacity" },
  { value: "spec_color" },
  { value: "spec_volume" },
  { value: "spec_model" },
  { value: "spec_quantity" },
  { value: "spec_flavor" },
  { value: "spec_scent" },
  { value: "spec_ingredient" },
  { value: "spec_use" },
  { value: "仓库" },
];

export function getSysSpecName(name) {
  for (var item of sysSpeclist)
    if (name == item.value) return i18n.t("newspecs." + name);
  return name;
}

export function initSaleCfg() {
  var nameList = [
    { retailType: 0, name: "小程序" },
    { retailType: 1, name: "抖音" },
    { retailType: 2, name: "鲸芽" },
    { retailType: 3, name: "Luck Seller" },
    { retailType: 4, name: "淘宝全球购" },
    { retailType: 5, name: "京东" },
    { retailType: 6, name: "小红书" },
    { retailType: 7, name: "快手" },
    { retailType: 8, name: "抖音海外版" },
    { retailType: 9, name: "SHOPLINE" },
    { retailType: 10, name: "拼多多" },
    { retailType: 11, name: "得物" },
    { retailType: 12, name: "Shopee" },
    { retailType: 13, name: "PitchPop" },
    { retailType: 14, name: "SHOPIFY" }
  ];
  httpRequest({
    url: httpRequest.adornUrl(`/saleQudao/cfg/all`), ////获取当前销售国家
    method: "get",
  }).then(({ data }) => {
    cfgItem.qudaoList = data;
    cfgItem.dateTime = Date.now();
    for (var i in cfgItem.qudaoList) {
      cfgItem.qudaoList[i].qudaoName = "";
      for (var mt of nameList)
        if (mt.retailType == cfgItem.qudaoList[i].retailType) {
          cfgItem.qudaoList[i].qudaoName = mt.name;
          break;
        }
    }
    sessionStorage.setItem(
      "platformSaleCountryConfig",
      JSON.stringify(cfgItem)
    );
  });

  httpRequest({
    url: httpRequest.adornUrl(`/platform/partner/distribution/mode`), 
    method: "get",
  }).then(({ data }) => {
    cfgItem.wechatDistMode = data;
    sessionStorage.setItem(
      "platformSaleCountryConfig",
      JSON.stringify(cfgItem)
    );
  });
}
export function getCFGwechatDistMode() {
  if (cfgItem.dateTime == 0) {
    var item = sessionStorage.getItem("platformSaleCountryConfig"); ////页面reload 后重新加载配置信息
    if (item != null) cfgItem = JSON.parse(item);
    else initSaleCfg();
  }
  return cfgItem.wechatDistMode;
}
export function getCFGQudaoName(sysUserId) {
  if (sysUserId == null) return "";
  if (cfgItem.dateTime == 0) {
    var item = sessionStorage.getItem("platformSaleCountryConfig"); ////页面reload 后重新加载配置信息
    if (item != null) cfgItem = JSON.parse(item);
    else initSaleCfg();
  }
  for (var it of cfgItem.qudaoList)
    if (it.sysUserId == sysUserId) return it.qudaoName;
  return "";
}

export function getCFGRetailTypeCny(retailType) {
  if (cfgItem.dateTime == 0) {
    var item = sessionStorage.getItem("platformSaleCountryConfig"); ////页面reload 后重新加载配置信息
    if (item != null) cfgItem = JSON.parse(item);
    else initSaleCfg();
  }
  for (var it of cfgItem.qudaoList)
    if (it.retailType == retailType) return getCurrencyName(it.priceCurrency);
  return "";
}
export function getSysImageAddr(url) {
  if (typeof url == "undefined") return "";
  if (url == null || url == "") return "";
  return url.toLowerCase().startsWith("http")
    ? url
    : window.SITE_CONFIG.resourcesUrl + url;
}
export function getCFGQudaoList(code) {
  var items = [];
  if (cfgItem.dateTime == 0) {
    var item = sessionStorage.getItem("platformSaleCountryConfig"); ////页面reload 后重新加载配置信息
    if (item != null) cfgItem = JSON.parse(item);
    else initSaleCfg();
  }
  for (var it of cfgItem.qudaoList)
    if (it.countryCode == code)
      items.push({
        value: it.sysUserId,
        retailType: it.retailType,
        label: it.qudaoName,
      });
  return items;
}
export function getCFGCurrencyList(code) {
  var items = [];
  if (cfgItem.dateTime == 0) {
    var item = sessionStorage.getItem("platformSaleCountryConfig"); ////页面reload 后重新加载配置信息
    if (item != null) cfgItem = JSON.parse(item);
    else initSaleCfg();
  }
  for (var it of cfgItem.qudaoList)
    if (it.countryCode == code) {
      var m = 0;
      for (var ut of items) if (ut.value == it.priceCurrency) m = 1;
      if (m == 0)
        items.push({
          value: it.priceCurrency,
          label: getCurrencyName(it.priceCurrency),
        });
    }
  return items;
}

export function retailSysUserIdCfg(retailType) {
  if (cfgItem.dateTime == 0) {
    var item = sessionStorage.getItem("platformSaleCountryConfig"); ////页面reload 后重新加载配置信息
    if (item != null) cfgItem = JSON.parse(item);
    else initSaleCfg();
  }
  for (var it of cfgItem.qudaoList)
    if (it.retailType == retailType) return it.sysUserId;
  return "";
}
